<template>
  <div>
    <div
      v-if="this.resizeEdges.includes('t')"
      class="vue-modal-top"
    ></div>
    <div
      v-if="this.resizeEdges.includes('b')"
      class="vue-modal-bottom"
    ></div>
    <div
      v-if="this.resizeEdges.includes('l')"
      class="vue-modal-left"
    ></div>
    <div
      v-if="this.resizeEdges.includes('r')"
      class="vue-modal-right"
    ></div>
    <div
      v-if="this.resizeEdges.includes('tr')"
      class="vue-modal-topRight"
    ></div>
    <div
      v-if="this.resizeEdges.includes('tl')"
      class="vue-modal-topLeft"
    ></div>
    <div
      v-if="this.resizeEdges.includes('br')"
      :id="getID"
      :class="className"
    ></div>
    <div
      v-if="this.resizeEdges.includes('bl')"
      class="vue-modal-bottomLeft"
    ></div>
  </div>
</template>
<script>
import { inRange, windowWidthWithoutScrollbar } from "../utils"

export default {
  name: "VueJsModalResizer",
  props: {
    minHeight: {
      type: Number,
      default: 0
    },
    minWidth: {
      type: Number,
      default: 0
    },
    maxWidth: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },
    maxHeight: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },
    viewportWidth: {
      type: Number,
      required: true
    },
    viewportHeight: {
      type: Number,
      required: true
    },
    resizeIndicator: {
      type: Boolean,
      default: true
    },
    resizeEdges: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      clicked: false,
      targetClass: "",
      size: {},
      initialX: 0,
      initialY: 0
    }
  },
  mounted() {
    this.$el.addEventListener("mousedown", this.start, false)
  },
  computed: {
    className() {
      const { clicked } = this
      return ["vue-modal-bottomRight", { clicked }]
    },
    getID() {
      if (this.resizeIndicator) return "vue-modal-triangle"
      else return ""
    }
  },
  methods: {
    start(event) {
      this.targetClass = event.target.className
      this.clicked = true
      this.initialX = event.clientX
      this.initialY = event.clientY

      window.addEventListener("mousemove", this.mousemove, false)
      window.addEventListener("mouseup", this.stop, false)

      event.stopPropagation()
      event.preventDefault()
    },

    stop() {
      this.clicked = false
      this.clicked = false
      this.targetClass = ""
      this.initialX = 0
      this.initialY = 0

      window.removeEventListener("mousemove", this.mousemove, false)
      window.removeEventListener("mouseup", this.stop, false)

      this.$emit("resize-stop", {
        element: this.$el.parentElement,
        size: this.size
      })
    },

    mousemove(event) {
      this.resize(event)
    },
    resize(event) {
      var el = this.$el.parentElement

      var width
      var height
      var styleWidth = el.offsetWidth
      var styleHeight = el.offsetHeight
      var styleLeft = el.offsetLeft
      var styleTop = el.offsetTop
      var deltaX = event.clientX - this.initialX
      var deltaY = event.clientY - this.initialY

      //Block Resize if mouse outside visable space.
      if (event.clientX > this.viewportWidth || event.clientX < 0) return
      if (event.clientY > this.viewportHeight || event.clientY < 0) return

      //Calcualte new  Widht/Height based on direction
      if (el) {
        switch (this.targetClass) {
          case "vue-modal-right":
            width = styleWidth + deltaX
            height = styleHeight
            break
          case "vue-modal-left":
            height = styleHeight
            width = styleWidth - deltaX
            break
          case "vue-modal-top":
            width = styleWidth
            height = styleHeight - deltaY
            break
          case "vue-modal-bottom":
            width = styleWidth
            height = styleHeight + deltaY
            break
          case "vue-modal-bottomRight":
            width = styleWidth + deltaX
            height = styleHeight + deltaY
            break
          case "vue-modal-topRight":
            width = styleWidth + deltaX
            height = styleHeight - deltaY
            break
          case "vue-modal-bottomLeft":
            width = styleWidth - deltaX
            height = styleHeight + deltaY
            break
          case "vue-modal-topLeft":
            width = styleWidth - deltaX
            height = styleHeight - deltaY
            break
          default:
            console.error("Incorrrect/no resize direction.")
        }

        const maxWidth = Math.min(windowWidthWithoutScrollbar(), this.maxWidth)
        const maxHeight = Math.min(window.innerHeight, this.maxHeight)
        width = inRange(this.minWidth, maxWidth, width)
        height = inRange(this.minHeight, maxHeight, height)
        var signX = /left/i.test(this.targetClass) ? -1 : /right/i.test(this.targetClass) ? 1 : 0
        var signY = /top/i.test(this.targetClass) ? -1 : /bottom/i.test(this.targetClass) ? 1 : 0
        this.initialX += signX * (width - styleWidth)
        this.initialY += signY * (height - styleHeight)

        this.size = { width, height }

        //Calculate growth in each dimension to be used when shifting the modal.
        const dimGrowth = {
          width: width - styleWidth,
          height: height - styleHeight
        }

        el.style.width = width + "px"
        el.style.height = height + "px"

        const anchorShift = {
          x:
            signX > 0
              ? el.offsetLeft - styleLeft
              : signX < 0
                ? el.offsetLeft + el.offsetWidth - styleLeft - styleWidth
                : 0,
          y:
            signY > 0
              ? el.offsetTop - styleTop
              : signY < 0
                ? el.offsetTop + el.offsetHeight - styleTop - styleHeight
                : 0
        }

        this.$emit("resize", {
          element: el,
          size: this.size,
          direction: this.targetClass,
          dimGrowth: dimGrowth,
          anchorShift: anchorShift
        })
      }
    }
  }
}
</script>
<style>
.vue-modal-top,
.vue-modal-bottom,
.vue-modal-left,
.vue-modal-right,
.vue-modal-topRight,
.vue-modal-topLeft,
.vue-modal-bottomLeft,
.vue-modal-bottomRight {
  position: absolute;
  z-index: 9999999;
  display: block;
  overflow: hidden;
  background: transparent;
}

.vue-modal-topRight,
.vue-modal-topLeft,
.vue-modal-bottomLeft,
.vue-modal-bottomRight {
  width: 12px;
  height: 12px;
}

.vue-modal-top {
  top: 0;
  right: 12;
  width: 100%;
  height: 12px;
  cursor: n-resize;
}

.vue-modal-bottom {
  bottom: 0;
  left: 0;
  width: 100%;
  height: 12px;
  cursor: s-resize;
}

.vue-modal-left {
  top: 0;
  left: 0;
  width: 12px;
  height: 100%;
  cursor: w-resize;
}

.vue-modal-right {
  top: 0;
  right: 0;
  width: 12px;
  height: 100%;
  cursor: e-resize;
}

.vue-modal-topRight {
  top: 0;
  right: 0;
  background: transparent;
  cursor: ne-resize;
}

.vue-modal-topLeft {
  top: 0;
  left: 0;
  cursor: nw-resize;
}

.vue-modal-bottomLeft {
  bottom: 0;
  left: 0;
  cursor: sw-resize;
}

.vue-modal-bottomRight {
  right: 0;
  bottom: 0;
  cursor: se-resize;
}

#vue-modal-triangle::after {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 0;
  height: 0;
  border-bottom: 10px solid #ddd;
  border-left: 10px solid transparent;
  background: transparent;
  content: "";
}

#vue-modal-triangle.clicked::after {
  border-bottom: 10px solid #369be9;
}
</style>
